import { Addition } from "@/pages/heat-report/models/HeatReportModels";
import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef, ValueGetterParams } from "ag-grid-enterprise";

export const useTableData = () => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Additions",
      children: [
        {
          field: "Timestamp",
          headerName: "Time",
          flex: 2,
          valueGetter: (params: any) => {
            if (params.data.Timestamp) {
              return dxtToLocalServerTime(
                (params.data as Addition).Timestamp,
                "HH:mm",
              );
            }
          },
        },
        {
          field: "MaterialName",
          headerName: "Material",
          flex: 2,
        },
        {
          field: "Weight",
          headerName: "Weight [lbs]",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Addition>) =>
            params.data?.Weight?.toFixed(0) || "0",
        },
      ],
    },
  ];

  return { columns };
};
